module.exports = __webpack_public_path__ + "static/img/img_awards_2.8c70675.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_2.png
// module id = Ez4U
// module chunks = 15